import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/member-login/page.tsx");
